import { atom } from "recoil";

export const contentHeaderTitleAtom = atom<string | undefined>({
  key: "contentHeaderTitleAtom",
  default: undefined,
});
